import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReply = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-348.44 -348.44 2488.89 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1792 416Q1792 250 1665 -35Q1662 -42 1654.5 -59.0Q1647 -76 1641.0 -89.0Q1635 -102 1628 -111Q1616 -128 1600 -128Q1585 -128 1576.5 -118.0Q1568 -108 1568 -93Q1568 -84 1570.5 -66.5Q1573 -49 1573 -43Q1578 25 1578 80Q1578 181 1560.5 261.0Q1543 341 1512.0 399.5Q1481 458 1432.0 500.5Q1383 543 1326.5 570.0Q1270 597 1193.5 612.5Q1117 628 1039.5 634.0Q962 640 864 640H640V384Q640 358 621.0 339.0Q602 320 576.0 320.0Q550 320 531 339L19 851Q0 870 0.0 896.0Q0 922 19 941L531 1453Q550 1472 576.0 1472.0Q602 1472 621.0 1453.0Q640 1434 640 1408V1152H864Q1577 1152 1739 749Q1792 615 1792 416Z"
	})
});
export default SvgReply;
